





















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Slider extends Vue {
  @Prop() public value!: number;
  @Prop({ default: 0 }) public min!: number;
  @Prop({ default: 100 }) public max!: number;
  @Prop({ default: false }) public showValue!: boolean;
}
